module.exports = __webpack_public_path__ + "static/media/PREVENCION_MATERIAL.b931da8f.png";